

const TRANSLATIONS_SV_SE = {
    "email_otp.back":"Tillbaka",
    "email_otp.enter_email_text":"Ange din e-postadress nedan för att få en unik kod skickad till dig",
    "email_otp.send_verification_link":"Skicka verifieringskod",
    "email_otp.resend_otp_with_timer":"Skicka om engångslösenord om",
    "email_otp.text":"Vi har skickat en sexsiffrig verifieringskod till [email]. Ange koden nedan",
    "email_otp.verify":"Verifiera",
    "reset_password.set_password":"Ställ in ditt lösenord",
    "sign_in.or":"eller",
    "sign_in.continue_with":"Eller fortsätt med",
    "sign_in.continue_with_email":"Eller fortsätt med e-post",
    "sign_in.create_without_password":"Skapa ett konto utan lösenord",
    "sign_in.create_with_otp":"Skapa ett konto med engångslösenord",
    "sign_in.login_with_otp":"Logga in med engångslösenord",
    "sign_in.login_without_password":"Logga in utan lösenord",
    "sign_in.tooltip_text":"Du kommer att få en tillfällig unik verifieringskod via e-post för att få tillgång till ditt konto.",
    "sign_up.tooltip_text":"Du kommer att få en tillfällig unik verifieringskod via e-post för att skapa ett konto.",
    "sign_in.password_updated":"Ditt lösenord har uppdaterats.",
    "sign_up.create_an_account":"Skapa ett konto",
    "email_otp.resend_otp":"Skicka om engångslösenord",
    "sign_up.email_address":"E-postadress",
    "sign_up.password":"Lösenord",
    "sign_in.create_account" : "Skapa ett konto",
    "sign_in.title": "Logga In",
    "sign_in.forgot_password" : "Glömt ditt lösenord?",
    "reset_password.resend_email": "Skicka om mejl",
    "reset_password.sent_title": "Mejl har skickats!",
    "reset_password.rcvResetLink": "Skriv er e-mail adress nedan och vi skickar en link där du kan ändra ditt lösenord",
    "reset_password.submit": "Skicka in",
    "reset_password.back_to_login": "Tillbaka till inloggning",
    "reset_password.create_new_password": "Skapa ett nytt lösenord för att logga in på ditt konto.",
    "forgot_password.emailSent": "Om det finns ett konto för [] kommer ett mejl att skickas med en återställningslänk för lösenord. Har det fortfarande inte kommit? Be om ett nytt mejl nedan.",
    "gdpr.continue": "Fortsätta",
    "validation.password_validation_heading": "Lösenordet måste innehålla:",
    "validation.password_length_ui": "Minst 8 tecken",
    "validation.password_upper_case_ui": "En versal",
    "validation.password_lower_case_ui": "En gemen",
    "validation.password_number_ui": "En siffra",
    "validation.password_symbol_ui": "Ett specialtecken",
    "verify_otp.customer_service_center_link": "s/kundtjänst",
    "activate_user.verification_successful.message": "Grattis! Ditt konto har aktiverats.",
    "activate_user.already_verified.message" : "Välkommen tillbaka! Ditt konto har redan verifierats.",

    // Errors Translation
    "sign_in.mandatory_field_error": "Fyll i alla obligatoriska fält innan du fortsätter.",
    "sign_in.invalid_email_error": "Ange e-postadress i rätt format, t.ex. namn@domän.com",
    "sign_in.invalid_credentials_error": "Du har angett ett ogiltigt användarnamn eller lösenord. Försök igen.",
    "sign_in.generic_error": "Något gick fel. Försök igen.",
    "sign_in.account_unverified_error": "Ditt konto har inte aktiverats än. Titta efter aktiveringslänken i din e-post, eller klicka på ”Har du glömt ditt lösenord?” för att återställa åtkomsten till kontot.",
    "sign_in.max_attempt_error": "Maximalt antal försök har gjorts. Försök igen senare.",
    "sign_in.social_signin_error": "Inloggning via sociala medier (Google/facebook/apple) misslyckades. Försök igen eller använd en annan inloggningsmetod",
    "sign_in.social_signin_email_not_present_error": "Inloggningen misslyckades. Försök igen eller använd ett annat inloggningsalternativ.",
    "sign_in.guest_user_signin_error": "Du verkar redan ha ett konto kopplat till den här e-postadressen. Klicka på ”Har du glömt ditt lösenord?” för att återställa tillgång till ditt konto.",

    "sign_up.mandatory_field_error": "Fyll i alla obligatoriska fält innan du fortsätter.",
    "sign_up.invalid_email_error": "Ange en giltig e-postadress, t.ex. namn@domän.com",
    "sign_up.password_length_error": "Lösenordet måste bestå av minst 8 tecken.",
    "sign_up.email_already_exist_error": "Den här e-postadressen används redan. Använd en annan e-postadress.",
    "sign_up.generic_error": "Något gick fel. Försök igen.",
    "sign_up.password_policy_error": "Lösenordet måste innehålla: en siffra, ett specialtecken [!#$%&'*+-/=?^_`{|}~.@] och stora och små bokstäver.",
    "sign_up.common_password_error": "Lösenordet får inte vara detsamma som din e-postadress",

    "forgot_password.mandatory_field_error": "Fyll i alla obligatoriska fält innan du fortsätter.",
    "forgot_password.invalid_email_error": "Ange e-postadress i rätt format, t.ex. namn@domän.com",
    "forgot_password.generic_error": "Något gick fel. Försök igen.",

    "reset_password.mandatory_field_error": "Fyll i alla obligatoriska fält innan du fortsätter.",
    "reset_password.password_history_error": "Lösenordet måste skilja sig från dina senaste fem lösenord.",
    "reset_password.password_length_error": "Lösenordet måste bestå av minst 8 tecken.",
    "reset_password.password_policy_error": "Lösenordet måste innehålla: en siffra, ett specialtecken [!#$%&'*+-/=?^_`{|}~.@] och stora och små bokstäver.",
    "reset_password.common_password_error": "Lösenordet får inte vara detsamma som din e-postadress",
    "reset_password.generic_error": "Något gick fel. Försök igen.",

    "email_otp.email_required_error": "Ange din e-postadress för att fortsätta",
    "email_otp.invalid_email_error": "Ange en giltig e-postadress, t.ex. namn@domän.com",
    "email_otp.generic_error": "Något gick fel. Försök igen senare",
    "email_otp.invalid_otp_error": "Engångslösenordet/verifieringskoden du angav är ogiltig. Försök igen.",
    "email_otp.resend_otp_error": "Kunde inte skicka om engångslösenord. Försök igen senare",
    "email_otp.verify_otp_error": "Något gick fel. Försök verifiera med engångslösenord igen senare",
    "email_otp.verify_otp_limit_exceed_error": "Engångslösenordet som angetts är ogiltigt. Klicka på ”Skicka om engångslösenord” för att få ett nytt",
    "email_otp.max_attempt_reached_error": "Maximalt antal försök har gjorts. Försök igen senare.",
    "email_otp.brute_force_error_part_1": "Ditt konto är tillfälligt låst på grund av flera misslyckade inloggningsförsök. Försök igen senare, eller ",
    "email_otp.brute_force_error_part_2": "kontakta vårt hjälpcenter",
    "email_otp.brute_force_error_part_3": ".",
    "form.gdprconsent": "Genom att logga in bekräftar du att du har läst och godkänner våra",
    "form.termsCondition": "regler och villkor",

    //Page Titles
    "sign_in.page_title": "Logga In | Pens.com",
    "sign_up.page_title": "Registrera Dig | Pens.com",
    "forgot-password.page_title": "Glömt Lösenord | Pens.com",
    "reset-password.page_title": "Återställ Lösenord | Pens.com",
    "sign-in.password_icon_aria_label_blured": "Blured Show password",
    "sign-in.password_icon_aria_label": "Show password",
    "sign-in.password_icon_aria_label_hidden": "Hide password",
    "sign-in.tooltip_icon_aria_label": "More Info",
    "email_otp.otp_digit_aria_label": "Please enter the code",
};
export default TRANSLATIONS_SV_SE;